




import AbpBase from "../../../lib/abpbase";
import AMap from "AMap"; // 引入高德地图
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
@Component
export default class amaps extends AbpBase {
async init() {
    var map = new AMap.Map("container", {
      resizeEnable: true, //是否监控地图容器尺寸变化
      zoom: 10, //初始化地图层级
      center: [114.502461, 38.045474], //初始化地图中心点
    });
    //信息窗口实例
    //var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) ,isCustom: true,});
    var infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30),
        anchor: "bottom",
        isCustom: true,
      });
    let lnglats= await this.$store.dispatch({
      type: "thequipment/getCountHomeEchart",
    });
    for (var i = 0; i < lnglats.length; i++) {
      var center = [lnglats[i].longitude,lnglats[i].latitude];
      // 创建一个 icon
      var Icon = new AMap.Icon({
        size: new AMap.Size(70, 70),
        image: require("../../../images/dingwei.gif"),
      });
      // 将 icon 传入 marker
      var Marker = new AMap.Marker({
        position: center,
        icon: Icon,
      });
      
      Marker.content =
        "<div class='MarkerContent' style='width: 150px; height: 200px; background-repeat: no-repeat;'>"+
			"<div style='display: table; padding: 20px 0 0 14px; '>"+
				"<img src='"+require("../../../images/dian.png")+"' style='margin-right: 10px; display: table-cell; vertical-align: middle;' />"+
				"<span style='font-size: 12px; font-weight: bold; display: table-cell; vertical-align: middle;'>"+lnglats[i].fname+"</span></div>"+
			"<div style='font-size: 12px; line-height: 26px; margin-top: 10px; padding: 0 20px 20px 20px ;'>" +
        "<span>设备总数："+lnglats[i].zCount+"</span><br>" +
        "<span>在线设备："+lnglats[i].zaixianCount+"<br>" +
        "<span>离线设备："+lnglats[i].lixianCount+"</span><br>" +
        "<span>预警设备："+lnglats[i].warningCount+"</span><br>" +
        "<span>低电量设备："+lnglats[i].didianliangCount+"</span><br></div>" +
        "</div>"
		"</div>"
      Marker.on("click", markerClick);
      Marker.emit("click", { target: Marker });
      function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
      }
      map.add(Marker);
    }
    //地图自适应
    map.setFitView();
  }
  mounted() {
    this.init();
  }
}
